// **************************************************************************
// CATALOG MANAGEMENT STATE
// Admin-specific state for catalog CRUD operations
// Note: Catalog list data is in entities/catalog/catalogs
// **************************************************************************

export interface CatalogManagementState {
    creating: boolean;
    deleting: boolean;
    uploadingImage: boolean;
}

export const initialCatalogManagementState: CatalogManagementState = {
    creating: false,
    deleting: false,
    uploadingImage: false,
};
